export const handleFileNameConvert = (filename) => {
    // Check if the file name ends with .jpeg or .png (case insensitive)
    let newFilename = filename.toLowerCase();

    if (newFilename.endsWith('.jpeg')) {
      newFilename = newFilename.slice(0, -5) + '.jpg';  // Remove the .jpeg and add .jpg
    } else if (newFilename.endsWith('.png')) {
      newFilename = newFilename.slice(0, -4) + '.jpg';  // Remove the .png and add .jpg
    }
    return newFilename
  };

  // Function to parse the array and convert filenames
export const convertFileNamesToPNG = (images) => {
  console.log("images in the Array",images);
  return images.map(image => ({
    ...image, // Spread the original image object
    fileName: handleFileNameConvert(image.name || image.fileName) // Apply conversion to fileName
  }));
};


